import { createContext, Suspense, useContext, useEffect } from "react";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { AdminLogin } from "./routes/Admin/Login";
import { UserTop } from "./routes/User/Top";
import { UserMyUserGroup } from "./routes/User/Courses";
import { AdminTop } from "./routes/Admin/Top";
import { AdminUserGroupTop } from "./routes/Admin/UserGroup";
import { UserLogin } from "./routes/User/Login";
import { CourseDetail } from "./routes/CourseDetail";
import { AdminUser } from "./routes/Admin/Users";
import { UserMyUserGroupUsers } from "./routes/User/Users";
import { useAuth } from "./routes/_shared/Auth";
import { Flex, Spinner } from "@chakra-ui/react";
import { CourseView } from "./routes/CoursePreview";
import { Redirect } from "./routes/User/Redirect";
import { AdminRedirect } from "./routes/Admin/Redirect";
import { GraphqlClientContext } from "./main";

function App() {
  const { graphqlClient } = useContext(GraphqlClientContext);
  useEffect(() => {
    if (!graphqlClient.subscribeToDebugTarget) return;
    const { unsubscribe } = graphqlClient.subscribeToDebugTarget((event) => {
      if (event.source === "dedupExchange") return;
      if (event.type === "fetchRequest") {
        const body = JSON.parse(event.data.fetchOptions.body);
        console.log(
          `[urql] (fetchRequest)\nquery: ${
            body.query
          }\nvariables: ${JSON.stringify(body.variables)}`
        );
      }
      if (event.type === "fetchSuccess") {
        console.log(
          "[urql] (fetchSuccess) data:",
          JSON.stringify(event.data.value.data, null, 2)
        );
      }
    });
    return unsubscribe;
  });

  return (
    <BrowserRouter>
      <Routing />
    </BrowserRouter>
  );
}

const LoadingScreen = () => {
  return (
    <Flex h="100vh" w="100vw" bgColor={"#16181a"}>
      <Spinner position={"absolute"} w="full" h="full" />
    </Flex>
  );
};
export const AuthContext = createContext<{
  currentUserId: string | undefined;
  currentAdminId: string | undefined;
  refetchUserAuth: () => Promise<unknown>;
  refetchAdminAuth: () => Promise<unknown>;
}>({
  currentUserId: undefined,
  currentAdminId: undefined,
  refetchUserAuth: () => Promise.resolve(),
  refetchAdminAuth: () => Promise.resolve(),
});

const Routing = () => {
  const {
    isUser,
    isAdmin,
    currentUserId,
    currentAdminId,
    refetchUserAuth,
    refetchAdminAuth,
  } = useAuth();
  return (
    <AuthContext.Provider
      value={{
        currentUserId,
        currentAdminId,
        refetchUserAuth,
        refetchAdminAuth,
      }}
    >
      <Suspense fallback={<LoadingScreen />}>
        <Routes>
          <Route
            path="/"
            element={isUser ? <UserTop /> : <Navigate replace to="/login" />}
          />
          <Route path="/login" element={<UserLogin />} />
          <Route
            path="/courses"
            element={
              isUser ? <UserMyUserGroup /> : <Navigate replace to="/login" />
            }
          />
          <Route
            path="/users"
            element={
              isUser ? (
                <UserMyUserGroupUsers />
              ) : (
                <Navigate replace to="/login" />
              )
            }
          />
          <Route
            path="/check"
            element={false ? <>redirecting...</> : <Navigate replace to="/" />}
          />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route
            path="/admin"
            element={
              isAdmin ? <AdminTop /> : <Navigate replace to="/admin/login" />
            }
          />
          <Route
            path="/admin/userGroups/:userGroupId"
            element={
              isAdmin ? (
                <AdminUserGroupTop />
              ) : (
                <Navigate replace to="/admin/login" />
              )
            }
          />
          <Route
            path="/admin/users"
            element={
              isAdmin ? <AdminUser /> : <Navigate replace to="/admin/login" />
            }
          ></Route>
          <Route path="/courses/view/:courseId" element={<CourseView />} />
          <Route path="/courses/:courseId" element={<CourseDetail />} />
          <Route path="/redirect_target" element={<Redirect />} />
          <Route path="/admin/redirect_target" element={<AdminRedirect />} />
        </Routes>
      </Suspense>
    </AuthContext.Provider>
  );
};

export default App;
